import { Component, OnInit, Input, SimpleChanges,ViewChildren } from '@angular/core';
import { LocalContentService } from '../../services/local-content/local-content.service'
import { Router } from "@angular/router";
import { DomSanitizer } from '@angular/platform-browser';
import { PipeTransform, Pipe } from "@angular/core";
import { VocabularyService } from '../../services/vocabulary/vocabulary.service';

@Pipe({ name: 'safeHtml' })
export class SafeHtmlPipe implements PipeTransform {
  constructor(private sanitized: DomSanitizer) { }
  transform(value) {
    return this.sanitized.bypassSecurityTrustHtml(value);
  }
}

@Component({
  selector: 'app-content-display',
  templateUrl: './content-display.component.html',
  styleUrls: ['./content-display.component.scss'],
})
export class ContentDisplayComponent implements OnInit {

  @Input() pageRef: string = null;
  @Input() contentOverride: string;
  @Input() executeNav: boolean = true;
  @Input() showNoTransMessage: boolean=false;
  public showNoContentMessage: boolean=false;

  @ViewChildren('sticky_bit') sticky_els;

  public sections: any[] = [];


  constructor(private localContentService: LocalContentService,private vS:VocabularyService,
    private router: Router) {
  }

  ngOnInit() {
    if (this.pageRef)
      this.localContentService.getStaticResource(this.pageRef).subscribe((res) => {
        let blob: any = res.body;
        var reader = new FileReader();
        reader.onerror = (e) => {
          this.setMDContent('');
          this.showNoContentMessage=true;
        }
        reader.onload = (e) => {
          let v=<string>reader.result;
          if (!v.length) this.showNoContentMessage=true;
          this.setMDContent(v);
        }
        reader.readAsText(blob);
      });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.contentOverride) {
      this.setMDContent(changes.contentOverride.currentValue)
    }
  }

  setMDContent(md: string) {

    window["globalcustomopen"] = (pageref) => this.navLink(pageref);

    //preserve fold up status
    let FUS = [];
    let FUCount = 0;
    this.sections.forEach((sec) => {
      if (sec.isHeader)
        FUS.push(sec.expanded);
    });
    //parse it by new lines
    if (md.length == 0) return;

    let bits = md.split('\n');

    //go through checking for headings
    let lastHeader = null;
    const linkRegex = /^\[(.+)\]\((.+)\)/;
    const imgRegex = /^!\[(.+)\]/;
    const b1Regex = /^-(([^\s]+)-)? /;
    const b2Regex = /^ -(([^\s]+)-)? /;
    const b3Regex = /^  -(([^\s]+)-)? /;

    this.sections = bits.map((b) => {
      let type = 't';
      let isHeader = false;
      let text = b;
      let imageI: any = 0;
      if ((b == "#") || b == "# ") { //explcit end of block
        type = 'G';
        lastHeader = null;
      } else if (b.startsWith("# ")) {
        isHeader = true;
        type = 'h';
        text = b.substring(2);
      } else if (b1Regex.test(b)) {
        let res = b1Regex.exec(b);
        imageI = res[2] ? res[2] : '';
        type = res[2] ? 'B' : 'b';
        text = b.substring(res[0].length);
      } else if (b2Regex.test(b)) {
        let res = b2Regex.exec(b);
        imageI = res[2] ? res[2] : '';
        type = res[2] ? 'C' : 'c';
        text = b.substring(res[0].length);
      } else if (b3Regex.test(b)) {
        let res = b3Regex.exec(b);
        imageI = res[2] ? res[2] : '';
        type = res[2] ? 'D' : 'd';
        text = b.substring(res[0].length);
      } else if (b.startsWith("![")) {
        let res = imgRegex.exec(b);
        type = 'i';
        text = 'unknown.png';
        imageI = +res[1];
      } else if (linkRegex.test(b)) {
        let res = linkRegex.exec(b);
        type = 'l';
        text = res[2];
        imageI = res[1];
      }
      else if (b.length < 2) {
        type = 'g';
      }
      let d = {
        isHeader: isHeader,
        type: type,
        contentHTML: this.toHTML(text),
        header: isHeader ? null : lastHeader,
        expanded: isHeader ? (!!FUS[FUCount]) : false,
        imageIndex: imageI,
      }
      if (isHeader) {
        lastHeader = d;
        FUCount += 1;
      }
      return d;
    });
  }

  toHTML(md: string): string {
    let act = false;

    md = md.replace(/\*\*/g, () => {
      act = !act;
      return act ? "<i>" : "</i>";
    });
    if (act) md += "</i>"; //unclosed italic in paragraph
    act = false;
    md = md.replace(/\*/g, () => {
      act = !act;
      return act ? "<b>" : "</b>";
    });
    if (act) md += "</b>"; //unclosed italic in paragraph
    //imbedded links
    md = md.replace(/\[(.+?)\]\((.+?)\)/g, '<a href="javascript:void(0);" onclick="window.globalcustomopen(\'$1\'); return false;">$2</a>');
    return md;
  }

  expand(section: any) {
    section.expanded = !section.expanded;
  }

  navLink(targetPageRef) {
    if (!this.executeNav) {
      alert('Switch to page: ' + targetPageRef);
      return;
    }
    this.router.navigate(['/content', targetPageRef])
  }


  private lastSticky=null;
  private lastStickyPos=0;

  outerScroll(event) {
    let pos=event.target.scrollTop;
    let endOne=null;
    let lastH=0;
    this.sticky_els.forEach(el=>{
      let epos=el.nativeElement.offsetTop;
      if (el.nativeElement==this.lastSticky) {
        epos=this.lastStickyPos;
      }
      if (epos<=pos+lastH) { //this is above
         endOne=el.nativeElement;
         lastH=el.nativeElement.offsetHeight;
      }
    });
    //check if the sticky has changed if so kill the old class and add a new class
    if (this.lastSticky==endOne) return; //no change

    if (this.lastSticky)
      this.lastSticky.classList.remove("stuck")
    if (endOne) {
      this.lastStickyPos=endOne.offsetTop;
      endOne.classList.add("stuck");
    }
    this.lastSticky=endOne;
  }

}
